<template>
  <!-- 酒店订单录入 -->
  <div class="app-container">
    <!-- <h1 class="title">{{ title || $t('route.offlineOrderEntry') }}</h1> -->
    <!-- <div>
      <span v-for="val in number" :key="val">{{val}}</span>
      <button @click="push">push一个数字8</button>
      <button @click="change">把数字1赋值为A(下标方式)</button>
      <button @click="changeLen">修改数组长度为2(赋值的方式)</button>
      <button @click="set">把数字1赋值为A(set方式)</button>
      <button @click="spliceLen">修改数组长度为2(splice方式)</button>
    </div> -->
    <el-form ref="form" :model="data" :label-width="$store.getters.language == 'en' ? '150px' : '100px'" :rules="rules">
      <!-- 酒店房型 -->
      <el-form-item :label="$t('order.HotelType')">
        <el-radio-group v-model="data.offline_model_id">
          <el-radio v-for="(item, key) in room_type_chose" :key="key" :label="key">{{ item }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-container style="margin-bottom:20px;">
        <el-aside :width="$store.getters.language == 'en' ? '370px' : '360px'" style="padding: 0;margin: 0;background: unset;">
          <!-- 订单来源 -->
          <el-form-item v-if="orderType != 'VIRTUAL'" :label="$t('order.client_type')">
            <el-select v-model="data.source_type_id" :placeholder="$t('order.selectOrder')" class="w160" @change="changetype">
              <el-option v-for="(item, key) in order_type_chose" :key="key" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <template>
            <!-- 到店时间 -->
            <el-form-item :label="$t('order.start_time')">
              <el-date-picker v-model="data.start_date" type="date" :placeholder="$t('order.selectDate')" :picker-options="pickerOptions1" class="w160" :clearable="false" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
            </el-form-item>
            <el-form-item>
              <el-select v-model="data.start_time" :placeholder="$t('order.choosetime')" class="w160">
                <el-option v-for="item in start_time_chose" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
            <!-- 入住时间早于12点 提示 -->
            <el-form-item v-if="data.offline_model_id != 3 && tip" class="alertTip">
              <el-alert :title="$t('order.hotel.tip1')" type="warning" :closable="false" />
            </el-form-item>
            <!-- 退房日期 -->
            <el-form-item v-if="data.offline_model_id != 3" :label="$t('order.CheckOutDate')">
              <el-date-picker v-model="data.end_date" type="date" :placeholder="$t('order.ChooseADte')" :picker-options="pickerOptions2" class="w160" :clearable="false" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
            </el-form-item>
            <!-- 天数 -->
            <el-form-item v-if="data.offline_model_id != 3" :label="$t('order.hotel.days')">
              <el-input v-model="and_day" :disabled="true" class="w160" />
            </el-form-item>
          </template>
          <!-- 选择时间段 -->
          <template v-if="data.offline_model_id == 3">
            <el-form-item :label="$t('order.SelectionTimePeriod')">
              <el-radio-group v-model="data.hour_len">
                <el-radio v-for="item in hour_len_chose" :key="item" :label="item">{{ item }}小时</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <!-- 下线录入(非虚拟单) -->
          <template v-if="orderType == 'OFFLINE'">
            <!-- 数量 -->
            <el-form-item :label="$t('order.Quantity')">
              <el-button type="primary" plain :disabled="data.room_num==1" @click="removeRoom(data.room_num-1)">-</el-button>
              <el-input id="center" v-model.number="data.room_num" style="width: 100px;text-align: center;" min="1" disabled />
              <el-button type="primary" plain @click="addRoom">+</el-button>
            </el-form-item>
            <!-- 币种 -->
            <el-form-item :label="$t('order.Currency')">
              <el-select v-model="data.fee_type" :placeholder="$t('order.Currency')" class="w160">
                <el-option v-for="(item, key) in fee_type_chose" :key="key" :label="item" :value="key" />
              </el-select>
            </el-form-item>
            <!-- 方式一 -->
            <el-form-item :label="$t('order.Amountcalculationmethod')">
              <el-radio v-model="radio" label="1" style="white-space: initial">{{ $t('order.Oneway') }}</el-radio>
              <el-radio v-model="radio" label="2" style="white-space: initial">{{ $t('order.Modetwo') }}</el-radio>
            </el-form-item>
            <!-- 方式二 -->
            <!-- <el-form-item>
            </el-form-item> -->
            <!-- 支付金额 -->
            <el-form-item v-if="radio=='1'" :label="$t('order.PaymentAmount')" required>
              <!-- 皇家花园 2房 -->
              <el-input v-model="data.money" :label="data.money" :placeholder="$t('setting.please_enter')+$t('order.PaymentAmount')" class="w160" @input="changePri" />
            </el-form-item>
            <!-- 单价(计算所得) -->
            <el-form-item v-if="radio=='1'" :label="$t('order.product_price')">
              <el-input v-model="unit_price" :disabled="true" :label="$t('order.product_price')" :placeholder="$t('setting.please_enter')+$t('order.PaymentAmount')" class="w160" />
            </el-form-item>
            <!-- 单价选择 :key="data.offline_model_id+'_'+key" -->
            <el-form-item v-if="radio=='2'" :label="pice_fee" required>
              <!-- :allow-create="isShow" :filterable="isShow" default-first-option // 可输入代码 -->
              <el-select v-model="unit_price1" :placeholder="$t('order.PaymentAmount')" class="w160">
                <el-option v-for="(item) in paymentAmountOption" :key="item.price" :label="item.value" :value="item.price" />
                <!-- 旅行社添加免费选项(2卧,3卧时) -->
                <el-option v-if="data.source_type_id == 7 && (data.offline_model_id == 1 || data.offline_model_id == 2)" label="0(旅行社免费)" :value="0" />
              </el-select>
            </el-form-item>
            <!-- 支付金额 -->
            <el-form-item v-if="radio=='2'" :label="$t('order.PaymentAmount')">
              <!-- 皇家花园 2房 -->
              <el-input v-model="data.money1" :disabled="true" :label="data.money1" class="w160" />
            </el-form-item>
          </template>
          <!-- 数量 -->
          <el-form-item v-if="orderType !== 'OFFLINE'" :label="$t('order.Quantity')">
            <el-input v-model.number="data.room_num" class="w160" min="1" />
          </el-form-item>
        </el-aside>
        <el-main style="padding:0;">
          <hotelOne v-if="data.offline_model_id == 1" :rightbox="false" />
          <hotelTwo v-if="data.offline_model_id == 2" :rightbox="false" />
          <hourRoom v-if="data.offline_model_id == 3" :rightbox="false" />
          <hotelr1 v-if="data.offline_model_id == 6" :rightbox="false" />
        </el-main>
      </el-container>
      <!-- 入住人信息 -->
      <template v-if="orderType == 'OFFLINE'">
        <el-form-item :label="$t('order.ResidentInformation')" class="touristItem">
          <div v-for="(item, index) in data.tourist" :key="index" class="touristContainer">
            <div class="side1">
              <el-tag type="info">{{ $t('order.Room') }}{{ index+1 }}</el-tag>
            </div>
            <div class="toursMain">
              <!-- 入住人姓名 -->
              <el-form-item :label="$t('order.NameOccupant') + ':'" required>
                <el-input v-model="data.tourist[index].name" :placeholder="$t('order.yourName')" :maxlength="40" class="w160" />
              </el-form-item>
              <!-- 护照号 -->
              <el-form-item :label="$t('order.PassportNumber') + ':'">
                <el-input v-model="data.tourist[index].id_no" :placeholder="$t('order.yourPassportNumber')" class="w160" />
              </el-form-item>

              <!-- 电话 -->
              <el-form-item :label="`电话:`">
                <el-input v-model="data.tourist[index].mobile" :placeholder="`请填写电话号`" class="w160" />
              </el-form-item>
              <!-- 手机号 -->
              <el-form-item :label="`手机号:`">
                <el-input v-model="data.tourist[index].phone" :placeholder="`请填写手机号`" class="w160" />
              </el-form-item>
              <!-- 邮箱专栏 -->
              <el-form-item :label="`邮箱专栏:`">
                <el-input v-model="data.tourist[index].email" :placeholder="`请填写邮箱`" class="w160" />
              </el-form-item>

              <!-- 航班号 -->
              <el-form-item :label="$t('order.FLT_No') + ':'" style="margin-right:10px;">
                <el-input v-model="data.tourist[index].come_flight_num" :placeholder="$t('order.FLT_No_num')" class="w160">
                  <template slot="prepend">{{ $t('order.fall_to_the_ground') }}</template>
                </el-input>
                -
                <el-input v-model="data.tourist[index].back_flight_num" :placeholder="$t('order.FLT_No_num')" class="w160">
                  <template slot="prepend">{{ $t('order.course_reversal') }}</template>
                </el-input>
              </el-form-item>
              <!-- 房间号 -->
              <el-form-item v-if="butPer.alp_offline_editTouristRoomNum" :label="$t('order.hotel.room_num') + ':'">
                <el-input v-model="data.tourist[index].room_num" :placeholder="$t('order.roomnumber')" class="w160" />
              </el-form-item>
              <!-- 增加/删除 -->
              <!-- <div class="side2">
                <el-button v-if="index === 0" type="success" icon="el-icon-plus" circle @click="addRoom" />
                <el-button v-else type="danger" icon="el-icon-delete" plain circle @click="removeRoom(index)" />
              </div> -->
            </div>
          </div>
        </el-form-item>
      </template>

      <!-- 入住说明 -->
      <el-form-item :label="$t('order.Stayinstructions')">
        <el-input v-model="data.remark" type="textarea" :placeholder="$t('order.checkinstructions')" />
      </el-form-item>
      <!-- 特殊需求 -->
      <el-form-item v-if="orderType == 'OFFLINE'" :label="$t('hotel.special_requirements')">
        <el-switch v-model="special_id" active-color="#13ce66" />
      </el-form-item>
      <!-- 特殊需求输入框 -->
      <el-form-item v-if="special_id" prop="special_remark">
        <el-input v-model="data.special_remark" type="textarea" :placeholder="$t('hotel.special_text')" />
      </el-form-item>
      <el-form-item>
        <!-- 立即创建 -->
        <el-button type="primary" @click="onSubmit">{{ $t('order.Createitnow') }}</el-button>
        <!-- 取消 -->
        <el-button @click="$emit('closedialog')">{{ $t('order.Cancel') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addOrder, room_price, validList } from '@/api/order' // , offline_price
// import { getCompany } from '@/api/car'
import { getPermission } from '@/utils/auth'
import hotelOne from '../hotel/inventoryview/HotelOne'
import hotelTwo from '../hotel/inventoryview/HotelTwo'
import hourRoom from '../hotel/inventoryview/HourRoom'
import hotelr1 from '../hotel/inventoryview/Hotelr1'
export default {
  name: 'Hotel',
  components: { hotelOne, hotelTwo, hourRoom, hotelr1 },
  props: {
    title: {
      type: String,
      default: ''
    },
    orderType: {
      type: String,
      default: ''
    },
    butPer: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      radio: '1', // 选择方式 1： 方式1；2：方式2
      isShow: false,
      data: {
        room_type: '1',
        offline_model_id: '1',
        order_type: 'OFFLINE',
        client_type: 3,
        source_type_id: undefined,
        start_date: undefined,
        end_date: undefined,
        hour_len: 3,
        start_time: '14:00',
        room_num: 1,
        product_price: undefined,
        fee_type: 'RMB',
        money: null,
        money1: null,
        tourist: [
          {
            name: '',
            id_no: '',
            room_num: '',
            come_flight_num: '',
            back_flight_num: ''
          }
        ],
        remark: undefined,
        is_special: undefined,
        special_remark: undefined
      },
      touristModel: {
        name: '',
        id_no: '',
        id_type: 2,
        room_num: '',
        come_flight_num: '',
        back_flight_num: ''
      },
      special_id: false,
      pice_fee: '单价',
      exchange_rate: undefined,
      num1: 1,
      input_0: undefined,
      input_1: undefined,
      room_type_chose: {
        1: this.$t('hotel.hotel2'), // 皇家花园2卧2房
        // 5: this.$t('hotel.hotel1'), // 皇家花园2卧1房
        2: this.$t('hotel.hotelr3'), // 皇家花园-3卧
        // 4: this.$t('hotel.hotel24') // 皇家花园-2卧24小时房
        3: this.$t('order.ChinatownHourHouse') // 中国城-钟点房
        // 6: this.$t('hotel.hotelr1') // 皇家花园-1房
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
      order_type_chose: {
        // OFFLINE: this.$t('order.Undertheline'),
        AILVPAI: this.$t('order.ailvpai'), // 爱旅拍
        LVXINGSHE: this.$t('order.lvxingshe'), // 旅行社
        SHIBEIKEJI: this.$t('order.shibeikeji'), // 拾贝科技
        SHANSHUIDICHAN: this.$t('order.shanshuidichan'), // 山水地产
        OTA: this.$t('order.Other')
      },
      // 时间段 3 6 24
      hour_len_chose: [3, 6, 24],
      unit_price: 0,
      unit_price1: 0,
      // 开始时间
      start_time_chose: [],
      // 币种
      fee_type_chose: {
        RMB: this.$t('order.RMB'),
        IDR: this.$t('order.Rupiah')
      },
      runtime: undefined,
      fee_type_arr: {},
      permission: {},
      preName: this.$route.name,
      paymentAmountOption: {},
      price_arr: undefined,
      old_fee_type: undefined,
      rules: {
        remark: [{ required: true, message: this.$t('order.checkinstructions'), trigger: 'blur' }]
      },
      and_day: 1,
      tip: false // 提示
    }
  },
  computed: {
    lang() {
      return this.$store.getters.language
    }
  },
  watch: {
    lang() {
      this.room_type_chose = {
        1: this.$t('hotel.hotel2'),
        // 5: this.$t('hotel.hotel1'),
        2: this.$t('hotel.hotelr3'),
        // 4: this.$t('hotel.hotel24'),
        3: this.$t('order.ChinatownHourHouse')
        // 6: this.$t('hotel.hotelr1') // 皇家花园-1房
      }
    },
    // 监听到店时间 start_time
    'data.start_time': function() {
      this.Total_amount_paid()
      // console.log(1)
      this.changePri()
    },
    // 监听到店日期
    'data.start_date': function() {
      this.start_end_time()
      // console.log(2)
      this.changePri()
    },
    'data.end_date': function() {
      this.start_end_time()
      // console.log(3)
      this.changePri()
    },
    // 监听币种
    'data.fee_type': function() {
      // console.log.log(this.data.fee_type)
      if (this.data.fee_type === 'RMB') {
        this.price_arr = this.fee_type_arr.RMB
      } else {
        this.price_arr = this.fee_type_arr.IDR
      }
      this.room_type_num()
    },
    // 监听选择时间段
    'data.hour_len': function() {
      let num1 = parseInt(this.data.offline_model_id)
      let pay_Option = this.price_arr[num1][this.data.hour_len]
      // this.unit_price = this.price_arr[num1][this.data.hour_len][0].price
      this.paymentAmountOption = pay_Option
      this.Total_amount_paid()
    },
    // 监听单价改变
    unit_price1: function() {
      // console.log(this.unit_price1)
      this.Total_amount_paid()
    },
    // 监听房间类型
    'data.offline_model_id': function() {
      this.room_type_num()
    },
    // 监听数量
    'data.room_num': function() {
      this.Total_amount_paid()
    },
    paymentAmountOption: function() {
      this.unit_price1 = this.paymentAmountOption[0].price
    }
  },
  created() {
    // console.log(this.butPer, 23456234567893456789)
    // 初始化到店时间和离店时间
    this.initialize_time()
    // 钟点房开始时间列表
    var t = []
    for (let i = 0; i < 48; i++) {
      var a = parseInt(i / 2)
      var b = parseInt(i % 2)
      t[i] = a > 9 ? a : '0' + a
      t[i] += ':'
      t[i] += b > 0 ? '30' : '00'
    }
    this.start_time_chose = t
    // console.log(22222, t)

    // 虚拟订单录入选项
    if (this.orderType) {
      this.data.order_type = this.orderType
    }
    // 获取房间类型单价
    this.getroom_pice()
    // 获取订单来源
    this.getorder_source()
  },
  methods: {
    // 监听到店离店时间数据公用方法
    start_end_time() {
      // console.log(this.data.start_date)
      if (!this.data.start_date) {
        this.initialize_time()
      }

      var reg = new RegExp('-', 'g')
      let and_day =
        (new Date(this.data.end_date.replace(reg, ',')) -
          new Date(this.data.start_date.replace(reg, ','))) /
        (24 * 60 * 60 * 1000)
      let date = new Date(this.data.start_date)
      if (and_day <= 0) {
        let now_date = this.formatDate(date)
        this.data.start_date = now_date[0]
        this.data.end_date = now_date[1]
        this.and_day = 1
      } else {
        this.and_day = and_day
      }
      let pickerOptions2 = {
        disabledDate(time) {
          return time.getTime() < date
        }
      }
      this.pickerOptions2 = pickerOptions2
      // console.log(date)

      this.Total_amount_paid()
    },
    // 初始化到店时间和离店时间公用方法
    initialize_time() {
      let now_date = this.formatDate(Date.now())
      this.data.start_date = now_date[0]
      this.data.end_date = now_date[1]
      // let h = now_date[2]
      // let m = now_date[3]
      // console.log(m)
      // if (m > 30) {
      //   h = h + 1
      //   h = h > 9 ? h : '0' + h
      //   h += ':00'
      // } else {
      //   h = h > 9 ? h : '0' + h
      //   h += ':30'
      // }
      // console.log(h)
      this.permission = getPermission()
    },
    // 监听房间类型
    room_type_num() {
      let num1 = parseInt(this.data.offline_model_id)
      if (num1 === 3) {
        let pay_Option = this.price_arr[num1][this.data.hour_len]
        // this.unit_price = this.price_arr[num1][this.data.hour_len][0].price
        this.paymentAmountOption = pay_Option
      } else if (num1 === 4) {
        let pay_Option = this.price_arr[num1]
        // this.unit_price = this.price_arr[num1][0].price
        this.paymentAmountOption = pay_Option
      } else {
        let pay_Option = this.price_arr[num1]
        // this.unit_price = this.price_arr[num1][0].price
        this.paymentAmountOption = pay_Option
      }
      this.Total_amount_paid()
      this.changePri()
    },
    // 获取当前时间
    formatDate(value) {
      let date = new Date(value)
      let nextValue = new Date(value).getTime() + 86400000
      let start_date = this.formatNewDate(value)
      let end_date = this.formatNewDate(nextValue)
      let h = date.getHours()
      let m = date.getMinutes()
      this.runtime = new Date(this.data.start_date)
      let time_arr = [start_date, end_date, h, m]
      return time_arr
    },
    formatNewDate(value) {
      let date = new Date(value)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      return y + '-' + MM + '-' + d
    },
    // 计算总的支付金额
    Total_amount_paid() {
      // 计算天数
      var reg = new RegExp('-', 'g')
      let and_day =
        (new Date(this.data.end_date.replace(reg, ',')) -
          new Date(this.data.start_date.replace(reg, ','))) /
        (24 * 60 * 60 * 1000)
      // 判断非钟点房和24小时房时间段小于12点天数加1
      let num1 = parseInt(this.data.offline_model_id)
      if (num1 !== 3 && num1 !== 4) {
        let start_time_arr = this.data.start_time.split(':')
        let start_time_hour = parseInt(start_time_arr[0])
        if (start_time_hour < 12) {
          and_day++
          this.tip = true
        } else {
          this.tip = false
        }
      }
      if (num1 === 3) {
        this.data.money1 = this.unit_price1 * this.data.room_num
      } else {
        this.data.money1 = this.unit_price1 * this.data.room_num * and_day
      }
      // console.log(this.unit_price, this.date.room_num)
      this.and_day = and_day
      // console.log(this.unit_price)
      // console.log(this.data.room_num)
      // 获取数量 单价  汇率
      this.data.money1 = this.data.money1.toFixed()
      // console.log(this.data.money1)
    },
    // 获取订单来源
    getorder_source() {
      // getCompany
      let query = { is_offline: 1, type: 'HT' }
      validList({ filter: query }).then(response => {
        this.order_type_chose = response.data
        let keylist = []
        for (let key in response.data) {
          keylist.push(key)
        }
        if (this.orderType != 'VIRTUAL') {
          this.data.source_type_id = parseInt(response.data[keylist[0]].id)
          this.isShow = this.data.source_type_id == 9
        }
      })
    },
    // 获取房间类型单价
    getroom_pice() {
      let data = {
        type: 1
      }
      room_price(data).then(response => {
        this.price_arr = response.data.price.RMB
        this.fee_type_arr = response.data.price
        this.room_type_num()
      })
    },
    // 判断入住时间段是否小于当前时间
    judgment_time() {
      let num1 = parseInt(this.data.offline_model_id)
      let jubgment_tf = true
      if (num1 !== 3 && num1 !== 4) {
        let now_date = this.formatDate(Date.now())
        if (now_date[0] === this.data.start_date) {
          let start_time_arr = this.data.start_time.split(':')
          let start_time_hour = parseInt(start_time_arr[0])
          let start_time_mine = parseInt(start_time_arr[1])
          if (start_time_hour < now_date[2]) {
            jubgment_tf = false
          } else if (start_time_hour === now_date[2]) {
            if (start_time_mine < now_date[3]) {
              jubgment_tf = false
            }
          }
        }
      }
      return jubgment_tf
    },
    // 提交数据
    onSubmit() {
      // 没有订单来源时
      if (!this.orderType) {
        for (let item of this.data.tourist) {
          // console.log(item)
          if (!item.name) {
            this.$message.error(this.$t('order.namecannot'))
            return
          }
        }
      }
      // 是否有特殊需求
      if (this.special_id) {
        this.data.is_special = 2
        if (!this.data.special_remark) {
          this.$message.error(this.$t('hotel.special_text'))
          return
        }
      } else {
        this.data.is_special = 1
      }

      // 判断时间段是否小于当前时间
      if (!this.judgment_time()) {
        this.$message({
          message: this.$t('hotel.check_in_time'),
          type: 'warning'
        })
        return
      }
      if (this.radio == 1) {
        this.data.product_price = this.unit_price
      } else {
        this.data.product_price = this.unit_price1
        this.data.money = this.data.money1
      }

      // if (this.data.room_type === 'VILLATWO2') {
      //   this.data.money = this.paymentAmountOption[this.data.fee_type][this.data.money].value
      // }
      switch (this.data.offline_model_id) {
        case '1':
          this.data.room_type = 'VILLATWO'
          break
        case '2':
          this.data.room_type = 'VILLATHREE'
          break
        case '3':
          this.data.room_type = 'CHINATOWN'
          break
        case '4':
          this.data.room_type = 'TWOBEDSHOUR'
          break
        case '5':
          this.data.room_type = 'TWOBEDSALL'
          break
        default:
      }
      const data = {
        data: {}
      }
      data.data = this.data
      // 判断入住人姓名是否为空和护照号是否重复
      if (this.data.order_type === 'OFFLINE') {
        let temparr = []
        let id_noarr = []
        let tourarr = data.data.tourist
        for (let i = 0; i < tourarr.length; i++) {
          if (
            temparr.indexOf(tourarr[i].name) === -1 &&
            id_noarr.indexOf(tourarr[i].id_no) === -1
          ) {
            temparr.push(tourarr[i].name)
            if (tourarr[i].name.length === 0) {
              this.$message({
                message: this.$t('setting.please_enter') + this.$t('order.NameOccupant'),
                type: 'warning'
              })
              return
            }
            if (tourarr[i].id_no.length > 0) {
              id_noarr.push(tourarr[i].id_no)
            }
          } else {
            if (temparr.indexOf(tourarr[i].name) !== -1) {
              this.$message({
                message: this.$t('hotel.name_repeated'),
                type: 'warning'
              })
              return
            }
            if (id_noarr.indexOf(tourarr[i].id_no) !== -1) {
              this.$message({
                message: this.$t('hotel.passport_number_repeated'),
                type: 'warning'
              })
              return
            }
          }
        }
      }
      // console.log(this.data)
      // return
      addOrder(data).then(response => {
        this.$message({
          message: this.$t('order.Successful'),
          type: 'success'
        })
        this.$emit('submit', true)
        // 清空已输入的数据
        this.data.tourist = [this.touristModel]
        this.data.room_num = 1
        this.data.remark = undefined
        this.data.is_special = undefined
        this.data.special_remark = undefined
        this.special_id = false
        this.data.money = null
        this.unit_price = 0
      })
    },
    refresh() {
      this.$emit('filter', this.listquery)
    },
    // 增加房间
    addRoom() {
      var touristModel = {
        name: '',
        id_no: '',
        id_type: 2,
        room_num: '',
        come_flight_num: '',
        back_flight_num: ''
      }
      this.data.tourist.push(touristModel)
      this.data.room_num++
      this.changePri()
    },
    // 删除房间
    removeRoom(index) {
      this.data.tourist.splice(index, 1)
      this.data.room_num--
      this.changePri()
    },
    changetype(val) {
      // 改变订单来源
      this.isShow = val == 9
    },
    // 手动更改价格,计算单价
    changePri() {
      switch (this.data.fee_type) {
        case 'RMB':
          this.unit_price = (this.data.money / this.data.room_num / this.and_day).toFixed(2)
          break
        case 'IDR':
          this.unit_price = (this.data.money / this.data.room_num / this.and_day).toFixed()
          break
      }

      // console.log(this.data.fee_type, 'price = money ÷ room ÷ day')
      // console.log(`${this.unit_price}=${this.data.money}÷${this.data.room_num}÷${this.and_day}`)
      // console.log('--------------------')
    }
  }
}
</script>

<style lang="scss" scoped>
/* .tourist .el-input-group {
  width: 90%;
  color: #909399;
} */
.tourist .el-row:hover {
  background: rgb(236, 245, 255);
}
.tourist .el-row + .el-row {
  margin-top: 10px;
}
.tourist .el-input {
  width: auto;
  min-width: 120px;
}
.tab1 th,
.tab1 td {
  padding: 0;
  border: none;
}
.tab1 td {
  text-align: left;
  padding-left: 20px;
}
.tab1 .inp {
  width: 160px;
}
.w160 {
  width: 210px;
}
.touristItem {
  margin-bottom: 0;
  .touristContainer {
    display: flex;
    padding-top: 10px;
    position: relative;
    top: -10px;
    &:hover {
      background: rgb(217, 236, 255);
    }
    .toursMain {
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        margin-bottom: 10px;
      }
    }
    .side2 {
      margin-left: 80px;
    }
  }
}
.alertTip {
  margin-bottom: 8px;
  margin-top: -22px;
  .el-alert {
    padding: 0;
    width: 210px;
    background: unset;
    line-height: 1;
  }
}
</style>
